import '../../styles/header.css'
import CaretDownIcon from '../../img/caret-down-light.svg'
import { FaceBot } from '../../Services/imagesRequest'
import { chatbotName } from '../../Chatbot/config'

const Header = ({ onCloseChat }) => {

  return (
    <div className="headerComponent">
      <img src={FaceBot} alt="Bot Avatar" className="botAvatar" />
      <p className="headerText">Converse com {chatbotName}</p>
      <button
        className="headerButton"
        onClick={() => {
          onCloseChat()
        }}
      >
        <img src={CaretDownIcon} alt="Dropdown Icon" className="icon" />
      </button>
    </div>
  )
}

export default Header